import React, { useState } from "react";
import Popup2FA from "./TwoFa/popup2FA";
import { useDispatch, useSelector } from "react-redux";
import {
  disableTwoFactor,
  enableTwoFactor,
  getAdminData,
  getTwoFactorSecret,
} from "../../reducers/adminReducers";
import { toast } from "react-toastify";
import Recovery from "./TwoFa/Recovery";

const TwoFaSetting = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [twoFactorData, setTwoFactorData] = useState({});
  const [displayData, setDisplayData] = useState({});
  const [open, setOpen] = useState(false);
  const result = useSelector((state) => state.admin);
  const { loginAdmin } = result || {};
  const [recoveryPopup, setRecoveryPopup] = useState(false);
  const [recoveryCode, setRecoveryCode] = useState("");

  const handleClose = () => {
    setOpen(false);
    setTwoFactorData({});
    setDisplayData({});
  };

    const handleCloseRecovery = () => {
      setRecoveryPopup(false);
    };

  const handelClickOnTwoFA = async () => {
    if (loginAdmin?.twoFactorAuthEnabled) {
      setDisplayData({
        header: "Remove 2FA",
        title: "REMOVE TWO-FACTOR AUTHENTICATION",
        desc: "To remove 2FA from your account, you need access to your authenticator and enter the code below.",
        tagLine: "Enter 2FA code",
        btnText: "Remove 2FA",
        btnColor: "#cd412b9e",
        btnTextColor: "white",
        nextBtnText: "Cancel",
      });
      setTwoFactorData({
        qrImage: null,
        tempTwoFactorSecret: loginAdmin?.tempTwoFactorSecret,
        twoFactorAuthEnabled: loginAdmin?.twoFactorAuthEnabled,
      });
      setOpen(true);
    } else {
      setIsLoading(true);
      try {
        const response = await dispatch(getTwoFactorSecret());
        const { code, qrImage, tempTwoFactorSecret, twoFactorAuthEnabled } =
          response.payload.resultData || {};

        if (code === 200) {
          setTwoFactorData({
            qrImage: qrImage,
            tempTwoFactorSecret: tempTwoFactorSecret,
            twoFactorAuthEnabled: twoFactorAuthEnabled,
          });
          setDisplayData({
            header: "Set Up 2FA",
            title: "SET UP TWO-FACTOR AUTHENTICATION",
            desc: "Scan the QR code with the authenticator app of your choice or copy the secret key above.",
            tagLine: "Enter 2FA Code",
            btnText: "Enable 2FA",
            btnColor: "#66852f",
            btnTextColor: "#ddf2b8",
            nextBtnText: "Cancel",
          });
          setOpen(true);
        }
      } catch (error) {
        console.log("Error in handelClickOnTwoFA", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleEnableDisable2FA = async (code) => {
    try {
      const endPoint = twoFactorData?.twoFactorAuthEnabled
        ? disableTwoFactor
        : enableTwoFactor;
      const response = await dispatch(endPoint({ code }));
      if (response?.payload?.resultData?.code === 200) {
        toast.success(
          response?.payload?.resultData.message || "Operation successful",
        );
        dispatch(getAdminData());
        setDisplayData({});
        setTwoFactorData({});
        setOpen(false);
      } else {
        toast.error(response?.payload?.msg || "Something went wrong");
      }
      if (response?.payload?.resultData.recoveryCode) {
        setRecoveryPopup(true);
        setDisplayData({});
        setRecoveryCode(response?.payload?.resultData?.recoveryCode);
      }
    } catch (error) {
      console.error("Error enabling/disabling 2FA:", error);
    }
  };
  return (
    <div>
      {loginAdmin?.twoFactorAuthEnabled ? (
        <button
          onClick={handelClickOnTwoFA}
          type="submit"
          className="btn btn-secondary mt-4 mb-4">
          {isLoading ? "...loading" : "Disable 2FA"}
        </button>
      ) : (
        <button
          onClick={handelClickOnTwoFA}
          type="submit"
          className="btn btn-primary mt-4 mb-4">
          {isLoading ? "...loading" : "Enable 2FA"}
        </button>
      )}
      {open && !isLoading && (
        <Popup2FA
          open={open}
          handleClose={handleClose}
          displayData={displayData}
          twoFactorData={twoFactorData}
          handleClick={handleEnableDisable2FA}
        />
      )}

      <Recovery
        open={recoveryPopup}
        recoveryCode={recoveryCode}
        handleCloseRecovery={handleCloseRecovery}
      />
    </div>
  );
};

export default TwoFaSetting;
